import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '../views/Login.vue'
import TcoWorkbench from '../components/HelloWorld.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: TcoWorkbench
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard to check authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('isAuthenticated') === 'true'
  
  // If route requires auth and user is not authenticated, redirect to login
  if (to.path !== '/login' && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router
